import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const PUBLIC_PREFIXES = ["/c/", "/privacy", "/regolamento", "/concorsi", "/accedi", "/i-miei-premi", "/gioca", "/embed"];
const KEY = "vw_cookie_ok";

export default function CookieBanner() {
  const { pathname } = useLocation();
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "1");
  const isPublic = PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(p)) || (pathname === "/" && sessionStorage.getItem("vw_host_landing") === "landing");
  if (ok || !isPublic) return null;
  const m = pathname.match(/^\/(?:regolamento|privacy|gioca|embed)\/([^/?]+)/);
  const privacyHref = m ? `/privacy/${m[1]}` : "/privacy";
  const accept = () => { localStorage.setItem(KEY, "1"); setOk(true); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4 pointer-events-none [&>*]:pointer-events-auto" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white border border-border text-foreground shadow-2xl p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <Cookie className="h-6 w-6 text-[var(--nc-blue)] shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm text-slate-700 flex-1">Questo sito usa solo cookie tecnici e la memoria del browser per far funzionare il gioco, il login e il conteggio anonimo delle visite. Nessun cookie di profilazione. <a href={privacyHref} className="underline text-[var(--nc-blue)] font-semibold" data-testid="cookie-banner-privacy">Leggi l'informativa privacy</a>.</p>
        <button type="button" onClick={accept} className="rounded-full bg-[var(--nc-blue)] text-white font-semibold text-sm px-5 py-2 hover:opacity-90 shrink-0" data-testid="cookie-banner-accept">Ho capito</button>
      </div>
    </div>
  );
}
